<template>
    <section class="principal">

        <div class="fondo"></div>

        <div class="titulo">

            <div class="texto">
                <h1>Team Building</h1>
                <p>Programas a medida para aprovechar al máximo tu <strong>crédito anual FUNDAE.</strong></p>
                
                <a onclick="document.getElementById('workshops').scrollIntoView({behavior: 'smooth'})" 
                class="btn btn-primary" 
                style="cursor: pointer;">
                Ver catálogo
                </a>

            </div>

            <div class="imagen-titulo">
                <img src="/images/teambuilding/tituloteambuilding.png" alt="Logo Team Building">
            </div>

            

        </div>

        <div class="contenido">

            <div class="contenedor-ventajas">
                <h2>Nuestros <strong>workshops</strong> no son solo actividades lúdicas; impulsan el <span> desarrollo profesional</span> y la <span> mejora del ambiente de trabajo.</span></h2>
                <ul>
                        <li>
                            <i class="fas fa-fist-raised"></i>
                            <span>Aumenta la motivación y el compromiso.</span>
                        </li>
                        <li>
                            <i class="fas fa-handshake"></i>
                            <span>Refuerza la colaboración y el trabajo en equipo.</span>
                        </li>
                        <li>
                            <i class="fas fa-lightbulb"></i>
                            <span>Potencia la creatividad y la innovación.</span>
                        </li>

                        <li>
                            <i class="fas fa-spa"></i>
                            <span>Reduce el estrés y mejora el clima laboral.</span>
                        </li>
                        <li>
                            <i class="fas fa-comments"></i>
                            <span>Fomenta la confianza y la comunicación.</span>
                        </li>
                        <li>
                            <i class="fas fa-chart-line"></i>
                            <span>Impulsa la productividad de la empresa.</span>
                        </li>
                </ul>
            </div>

            <div id="workshops" class="contenedor-workshops">
                <h3>Workshops Destacados</h3>

                <div class="workshops-grid">
                
                    <WorkshopCard
                        v-for="workshop in workshopsDestacados"
                        :key="workshop.id"
                        :workshop="workshop"
                    />
                    
                </div>

                <div class="contenedor-dosier">
                    <h4>Descarga el dosier para ver todos los workshops. </h4>
                    <p>¡16 opciones disponibles!</p>
                    <button @click="abrirFormDosier" class="boton-dosier">Ver Dosier Informativo</button>
                </div>

                <div v-if="mostrarFormDosier" class="fondo-formulario" @click.self="cerrarFormDosier">
                    <div class="contenedor-formulario">
                        <button type="button" class="boton-cerrar" @click="cerrarFormDosier">
                        <i class="fa-solid fa-x"></i>
                        </button>

                        <h2>Ver Dosier Informativo</h2>

                        <form @submit.prevent="guardarYDescargarDosier">
                        <label>
                            Nombre completo
                            <input v-model="formDosier.nombre" type="text" required />
                        </label>

                        <label>
                            Nombre de la empresa
                            <input v-model="formDosier.empresa" type="text" required />
                        </label>

                        <label>
                            Correo electrónico profesional
                            <input v-model="formDosier.email" type="email" required />
                        </label>

                        <label>
                            Teléfono
                            <input v-model="formDosier.telefono" type="tel" required />
                        </label>

                        <button type="submit" class="boton-enviar">Enviar y abrir dosier</button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        
    </section>
</template>

<script>
import WorkshopCard from '@/components/WorkshopCard.vue';
import { db } from "@/db/firebase"
import { collection, addDoc } from "firebase/firestore"

export default {
    name: 'TeamBuildingView',
    components: {
        WorkshopCard
    },
    data() {
        return {
            workshopsDestacados: [
                {
                    id: 1,
                    nombre: ' Taller de pasta fresca',
                    descripcion: ' Elabora tu propia pasta y degústala en equipo',
                    beneficio: 'Refuerza la colaboración y la coordinación',
                    imagenSrc: '/images/teambuilding/pasta.jpg'
                },
                {
                    id: 2,
                    nombre: 'Taller de peinado de valenciana',
                    descripcion: 'Realiza el tradicional peinado de valenciana paso a paso.',
                    beneficio: 'Refuerza la cooperación y la conexión con las tradiciones valencianas.',
                    imagenSrc: '/images/teambuilding/fallera2.jpg'
                },
                {
                    id: 3,
                    nombre: ' Taller de robótica',
                    descripcion: 'Construye y programa un robot.',
                    beneficio: 'Potencia la cooperación y la resolución conjunta de retos.',
                    imagenSrc: '/images/teambuilding/robotica.webp'
                },
                {
                    id: 4,
                    nombre: 'Taller de cóctelería',
                    descripcion: 'Aprende a preparar cócteles únicos.',
                    beneficio: 'Refuerza la creatividad y la comunicación.',
                    imagenSrc: '/images/teambuilding/cocteleria.jpeg'
                },
                {
                    id: 5,
                    nombre: 'Taller de teatro',
                    descripcion: 'Representa escenas y juegos teatrales.',
                    beneficio: 'Refuerza la comunicación, improvisación y confianza mutua.',
                    imagenSrc: '/images/teambuilding/teatro.png'
                },
                {
                    id: 6,
                    nombre: 'Taller de IA y marketing digital',
                    descripcion: 'Explora herramientas de IA para diseñar campañas.',
                    beneficio: 'Potencia tu estrategia de marketing digital.',
                    imagenSrc: '/images/teambuilding/taller-ia.jpg'
                }
            ],
            mostrarFormDosier: false,
            formDosier: {
                nombre: '',
                empresa: '',
                email: '',
                telefono: ''
            }
        };
    },
    methods: {
        abrirFormDosier() {
            this.mostrarFormDosier = true;
        },
        cerrarFormDosier() {
            this.mostrarFormDosier = false;
        },
        async guardarYDescargarDosier() {
            try {
                
                await addDoc(collection(db, "dosier_teambuilding"), {
                    "01_nombre": this.formDosier.nombre,
                    "02_empresa": this.formDosier.empresa,
                    "03_email": this.formDosier.email,
                    "04_telefono": this.formDosier.telefono, 
                    "05_fecha": new Date()
                });

               
                this.cerrarFormDosier();

                setTimeout(() => {
                    const link = document.createElement('a');
                    link.href = '/images/teambuilding/DOSIER-TEAMBUILDING-GRUPO-STUDIO.pdf';
                    link.target = '_blank';
                    link.click();
                }, 500);

             
                this.formDosier = { nombre: '', empresa: '', email: '', telefono: '' };
                
                alert("¡Datos registrados! se te redirigirá automáticamente.");

            } catch (error) {
                console.error("Error al procesar la solicitud:", error);
                alert("No se pudo procesar la solicitud. Inténtalo de nuevo.");
            }
        },
    }
}
</script>

<style lang="scss" scoped>

*{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.principal{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    position: relative;
}

.fondo{
    background-image: url('@/assets/fondopracticas.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -5; 
}

.titulo{
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 80px;

    .texto{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 46%;
        text-align: left;

        h1{
            font-size: 80px;
            font-weight: 700;
            color: #000000;
        }
        p{
            font-size: 36px;
            font-weight: 500;
            margin: 20px 0 0 0;
            line-height: 1.8;
            color: rgb(0, 0, 0);

            strong{
                color: #b30000;
                font-weight: 500;
            }
        }
        a{
            margin-top: 40px;
            padding: 15px 30px;
            background-color: #ae0000;
            color: rgb(255, 255, 255);
            border: 1px solid #ae0000;
            border-radius: 28px;
            text-decoration: none;
            font-weight: 600;
            font-size: 18px;
            cursor: pointer;
            font-family: 'montserrat', sans-serif;
            transition: 0.3s ease;
            &:hover{
                background-color: #ffecec;
                color: #ae0000;
            }
        }

    }

    .imagen-titulo{
        margin-top: 40px;

        img{
            width: 500px;
            height: auto;
        }
    }

    
}

.contenido{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.contenedor-ventajas{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;

    h2{
        margin-bottom: 60px;
        color: #585858;
        font-weight: 500;
        font-size: 21px;
        line-height: 2.4;
        text-align: center;
        width: 60%;
        letter-spacing: 0.5px;
        word-spacing: 1.5px;

        strong{
            color: #b30000;
        }

        span{
            color: #b30000;
            background-color: rgba(255, 246, 246, 0.8);
            padding: 5px 10px;
            border: 1px solid #b30000;
            border-radius: 20px;
        }
        
    }

    ul{
        list-style-type: none;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        gap: 40px;
        width: 100%;
        background-color: white;
        padding: 50px;
        border: 1px solid #ffcccc;
        box-shadow: 0 0 10px #1c000017;


            li{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 20px;
                
                span{
                    border-radius: 38px;
                    font-size: 20px;
                    font-weight: 500;
                    color: #6d6d6d;
                }

                i{
                    font-size: 25px;
                    color: #b40000;
                    background-color: #fff4f4;
                    padding: 15px;
                    border-radius: 50%;
                    border: 1px solid #ffbebe;
                    box-shadow: 0 0px 6px rgba(0, 0, 0, 0.1);
                }
            }
        
    }
}

.contenedor-workshops{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 10px;

    h3{
        margin-bottom: 20px;
        margin-top: 70px;
        color: #a70000;
        font-weight: 700;
        font-size: 25px;
        line-height: 1.9;
        text-align: center;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 20px; 
        width: 100%;

        &::before,
        &::after {
            content: "";
            flex: 1;
            height: 2px;      
            background-color: rgb(179, 0, 0);
            margin: 0 30px;  
        }

        
    }

    
}

.contenedor-dosier{
    margin-top: 50px;
    margin-bottom: 120px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 53%;
    border-left: 4px solid #b30000;

    h4{
        margin-bottom: 20px;
        color: #656565;
        font-weight: 600;
        line-height: 1.9;
        text-align: left;
        width: 100%;
        text-transform: uppercase;   
        
    }
    p{
        margin-bottom: 20px;
        font-weight: 600;
        line-height: 1.9;
        text-align: left;
        width: 100%;
        text-transform: uppercase;   
        color: #b30000;
        border-radius: 20px;
        font-style: italic;
    }

    
    .boton-dosier{
        border: 1px solid #ae0000;
        background-color: #fff6f6;
        font-size: 16px;
        font-family: 'montserrat', sans-serif;
        color: #b50000;
        padding: 12px 24px;
        border-radius: 28px;
        text-decoration: none;
        font-weight: 600;
        transition: background-color 0.3s ease;
        cursor: pointer;

        &:hover{
            background-color: #a20000;
            color: #ffffff;
        }
    }

}

.fondo-formulario {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000; 
}

.contenedor-formulario {
  position: relative;
  padding: 38px;
  border-radius: 12px;
  width: 90%;
  max-width: 450px;
  height: auto; 
  background: #fff9f9;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

h2 {
    text-align: center;
    margin-bottom: 25px;
    text-transform: uppercase;
    color: #af0000;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
}

form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    background: #ffffff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
}

label {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #555555;
}

input {
    margin-top: .3rem;
    padding: .6rem;
    border-radius: 20px;
    border: 1px solid #ccc;
    font-family: 'Montserrat', sans-serif;
}

.boton-enviar {
    background: #ffeeee;
    color: rgb(184, 0, 0);
    border: 2px solid rgb(184, 0, 0);
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    padding: 0.7rem 1.5rem;
    border-radius: 38px;
    cursor: pointer;
    margin-top: 10px;
    transition: 0.3s ease;

    &:hover {
        background: rgb(184, 0, 0);
        color: #ffffff;
    }
}

.boton-cerrar {
    position: absolute;
    top: 20px;
    right: 20px;
    border: none;
    background: none;
    color: rgb(184, 0, 0);
    cursor: pointer;
    font-size: 18px;
}

.workshops-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: 32px;
    padding: 32px;
    
    
}

@media (max-width: 1200px) {
    .workshops-grid {
        grid-template-columns: repeat(2, 1fr); 
    }
}

@media (max-width: 768px) {
    .titulo {
        flex-direction: column;
        text-align: center;
        gap: 10px;

        .texto, .imagen-titulo {
            width: 100%;
        }

        .texto {
            align-items: center;
            text-align: center;
            h1 {
                font-size: 48px;
            }
            p {
                font-size: 24px;
                margin: 10px 0 0 0;
            }
            a {
                margin-top: 10px;
                padding: 12px 24px;
                font-size: 16px;
            }
        }
        .imagen-titulo {
            margin-top: 10px;
            img {
                width: 80%;
                height: auto;
            }
        }
    }
    .contenido {
        .contenedor-ventajas {
            h2 {
                width: 90%;
                font-size: 18px;
                margin-bottom: 40px;
            }
            ul {
                flex-direction: column;
                align-items: center;
                padding: 40px 120px;
                gap: 20px;
                li {
                    span {
                        font-size: 16px;
                    }
                    i {
                        font-size: 20px;
                        padding: 10px;
                    }
                }
            }
        }
    }
    .workshops-grid {
        grid-template-columns: 1fr; 
    }

    .contenedor-dosier {
        width: 90%;
        margin-left: 20px;
        padding-left: 10px;
        align-items: flex-start;
        h4 {
            font-size: 16px;
        }
        .boton-primario {
            padding: 10px 20px;
            font-size: 16px;
        }
    }
}

</style>